/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { updatePolicyRequestModelSchema } from "../updatePolicyRequestModelSchema.ts";
import { z } from "zod";

/**
 * @description Политика обновлена
 */
export const putApiPolicy200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const putApiPolicy400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiPolicy401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiPolicy403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Политика не найдена
 */
export const putApiPolicy404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiPolicy500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiPolicyMutationRequestSchema = z.lazy(() => updatePolicyRequestModelSchema).describe("Тело запроса")

export const putApiPolicyMutationResponseSchema = z.lazy(() => putApiPolicy200Schema)